import React, {useState} from 'react';
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import Snackbar from '@mui/material/Snackbar';

import {Link as RouterLink} from "react-router-dom";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from "yup";
import {collection, doc, setDoc, serverTimestamp} from "firebase/firestore";
import {getFirebase} from "../../config/firebase.config";

const schema = yup.object({
    empName: yup.string().required("Employee name required!"),
    empId: yup.string().required("Employee Id required!"),
    email: yup.string().email("Invalid email address!").required("Email required!"),
}).required();

const formValues = {empName: '', empId: '', email: ''}

const AccountRequestForm = () => {
    const {firestore} = getFirebase();
    const [loading, setLoading] = useState(false);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const {handleSubmit, control, formState: {errors}, reset} = useForm({
        defaultValues: formValues,
        resolver: yupResolver(schema)
    });
    const onSubmit = async (data) => {
        setLoading(true)
        try {
            const newAccountRef = doc(collection(firestore, process.env.REACT_APP_ACCOUNT_REQUESTS));
            data.date = serverTimestamp();
            await setDoc(newAccountRef, data);
            setSnackBarOpen(true);
            reset(formValues);
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false);
        }
    }

    return (
        <Container component="main" maxWidth="xs">
            <Snackbar
                anchorOrigin={{vertical: "top", horizontal: "center"}}
                open={snackBarOpen}
                onClose={(event, reason) => setSnackBarOpen(false)}
                autoHideDuration={4000}
                message="Success! Your employee account will be reviewed by our staff soon."
            />
            <Box sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
            >
                <Avatar sx={{m: 1, width: 100, height: 100}} src="/logo.png"/>
                <Typography component="h1" variant="h4">Chautari Homecare LLC</Typography>
                <Typography variant="subtitle1" gutterBottom component="div">Missed EVV Request Employee
                    Account</Typography>
                <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{mt: 1}}>
                    <FormControl fullWidth>
                        <Controller
                            name="empName"
                            control={control}
                            render={({field}) =>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    label="Provide your name"
                                    autoComplete="empName"
                                    autoFocus
                                    error={!!errors.empName}
                                    helperText={errors.empName && errors.empName?.message}
                                    {...field}/>
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <Controller
                            name="empId"
                            control={control}
                            render={({field}) =>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    label="Provide your employeeId"
                                    autoComplete="employeeId"
                                    error={!!errors.empId}
                                    helperText={errors.empId && errors.empId?.message}
                                    {...field}/>
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <Controller
                            name="email"
                            control={control}
                            render={({field}) =>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    label="Provide your email address"
                                    autoComplete="email"
                                    error={!!errors.email}
                                    helperText={errors.email && errors.email?.message}
                                    {...field}
                                />
                            }
                        />
                    </FormControl>
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary"/>}
                        label="I accept terms and conditions."
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                        disabled={loading}
                    >
                        Request for an account
                    </Button>
                    <Grid container>
                        <Grid item>
                            <Link component={RouterLink} to="/auth/login" variant="body2">
                                Already have an account?
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
};

export default AccountRequestForm;